export const paymentMethods = [
    { code: 'paypal', label: 'PayPal' },
    { code: 'veem', label: 'Veem' },
];